import { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";
import {
  salesReturnTableAction,
  salesReturnViewAction,
  salesReturnVoidAction,
} from "../../../redux/actions/sales-action";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../../components/helper-components/success-toast";
import errorToast from "../../../components/helper-components/error-toast";
import { handlea4Print } from "../../../components/helper-components/helper-function";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import SalesPurchaseFilter from "../../../components/sales-section/sales-purchase-filter";
import BadgesComponent from "../../../components/tables/badges-component";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";
import ChartIncreaseIcon from "../../../assets/icons/sales-icons/chart-increase-icon";
import ClockIcon from "../../../assets/icons/sales-icons/clock-icon";
import FilmChartIcon from "../../../assets/icons/sales-icons/film-chart-icon";
import ArrowDownLeftIcon from "../../../assets/icons/sales-icons/arrow-down-left-icon";
const SalesReturn = () => {
  const [heading, setHeading] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState([]);
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});
  useEffect(() => {
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const transferData = parsed.find((obj) => obj?.sales_return_list);
      if (transferData?.sales_return_list) {
        setHeading(transferData.sales_return_list);
      }
    }
  }, []);
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    // selectColumn: "srt_invoice_number",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });
  useEffect(() => {
    dispatch(
      salesReturnTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList ?? []);
    setDataCount(data?.data?.totalCount);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);
  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.srt_id,
      srt_invoice_number:
        (
          <span className="fw_500 cursor-pointer">
            {item?.srt_invoice_number ?? "--"}
          </span>
        ) ?? "--",
      cmr_name: item?.cmr_name ?? "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "--",
      update_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "--",
      created_user_name: item?.created_user_name ?? "--",
      updated_user_name: item?.updated_user_name ?? "--",
      order_status: <BadgesComponent status={item?.srt_order_status} />,
      srt_total_amount: "₹ " + item?.srt_total_amount,
      is_draft_order: item?.is_draft_order,
      itemData: item?.itemData?.length > 0 ? item?.itemData : [],
      cmr_id: item?.cmr_id ?? "--",
      srt_order_status: item?.srt_order_status ?? "",
      is_voided: item?.is_voided ?? false,
      store_code: item?.store_code ?? "--",
      store_name: item?.store_name ?? "--",
      store_type: item?.store_type ?? "--",
      firm_name: item?.firm_name ?? "--",
      cmr_code: item?.cmr_code ?? "--",
      srt_reference_inv_number:item?.srt_reference_inv_number?? "--",
      srt_reference_inv_date: item?.srt_reference_inv_date? new Date(item.srt_reference_inv_date).toISOString().split("T")[0]: "--",
    };
  });
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".head-div")?.clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [loading]);
  const filterby = showFilter ? (
    <SalesPurchaseFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setCurrentPage={setCurrentPage}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Qty Returned",
      value: 0, //backend
      desc: `${0} Lakh`, //backend
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <ArrowDownLeftIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg. Return Value",
      value: `${0} `, //backend
      desc: `+${0}% vs last week`, //backend
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: <FilmChartIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Return Awaiting PCN",
      value: 0, //backend
      desc: `₹${0} pending`, //backend
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-red-fg)]",
      icon: <ClockIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Return",
      value: 0,
      desc: `+${0} vs last Week`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <ChartIncreaseIcon />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];
  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      onclkFn={() => {
        navigate(
          `/add-sales-return/${encodeURIComponent(JSON.stringify([]))}/return`
        );
      }}
      title="Sales Return"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            ViewAction={salesReturnViewAction}
            transaction="Sales Return"
            transaction_type="sales_return"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={invoiceItems}
            options={options}
            orders={orders}
            setOrders={setOrders}
            tableHeading1={tableHeading1}
            is_checkbox_req={true}
            onClickItemFn={(id) => navigate(`/view-sales-return/${id}`)}
            list={true}
            onclkFn={() => {
              navigate(
                `/add-sales-return/${encodeURIComponent(
                  JSON.stringify([])
                )}/return?new`
              );
            }}
            cloneFn={(id) => {
              navigate(
                `/add-sales-return/${encodeURIComponent(
                  JSON.stringify([])
                )}/return?cloneID=${id}`
              );
            }}
            permissionFn={permissionFn}
            module={"sales_return"}
            path="sales-return"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={salesReturnVoidAction}
            label="Sales Return"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "srt_invoice_number",
              from: "",
              to: "",
              inputValue: "",
              orderStatus: "",
            }}
            handleSelect={(item) => {
              if (item?.value === "delivery_note") {
                navigate(
                  `/add-delivery/${encodeURIComponent(
                    JSON.stringify(invoiceItems)
                  )}/return?type=srt&transfer=true`
                );
              } else {
                navigate(
                  `/add-sales-credit-note/${encodeURIComponent(
                    JSON.stringify(invoiceItems)
                  )}/return?type=srt&transfer=true`
                );
              }
            }}
            extraFilters={[
              { label: "Item Code", value: "item_code", column: true },
              { label: "Item Name", value: "item_name", column: true }
            ]}
            transactionKey="srt"
            actionsPermissions={{
              edit: ["draft"], // Edit allowed for "open" and "draft"
              delete: ["open", "draft"], // Delete allowed only for "open"
              print: ["open", "closed", "draft"], // Print allowed for "open" and "closed"
              send: ["open", "closed", "draft"], // Share allowed for "open" and "closed"
              clone: ["open", "draft", "closed"], // Clone allowed for "open", "draft" and "closed"
            }}
            summaryArray={summaryArray}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default SalesReturn;
const tableHeading = [
  {
    label: "SALES RETURN NUMBER",
    value: "srt_invoice_number",
    display: true,
    column: true,
  },
  {
    label: "CUSTOMER NAME",
    value: "cmr_name",
    display: true,
    column: true,
  },
  { label: "DATE", value: "update_date", display: true, column: false },
  {
    label: "ORDER STATUS",
    value: "order_status",
    display: false,
    column: false,
  },
  {
    label: <span className="flex justify-end">AMOUNT</span>,
    value: "srt_total_amount",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  { label: "", value: "", column: false },
];

const tableHeading1 = [
  { label: "PRODUCT NAME", value: "item_name" },
  { label: "GENERIC NAME", value: "item_generic_name" },
  { label: "ITEM CODE", value: "item_code" },
  { label: "UOM", value: "item_pack_size" },
  { label: "PRICE (₹)", value: "item_uom" },
  { label: "QTY", value: "item_quantity" },
  { label: "TOTAL (₹)", value: "item_total_amount" },
];

const options = [
  { value: "delivery_note", label: "Delivery Note" },
  { value: "sales_credit_note", label: "Sales Credit Note" },
];
